import { SubtitleOption, AudioOption, TrackSection } from "./types";

import { StreamingIcons } from "@/assets/iconFont/streaming-icons";

/**
 * Subtitle track options with ISO 639-1 language codes
 * "off" is a special case for disabling subtitles
 */
const SUBTITLE_OPTIONS: SubtitleOption[] = [
  { id: "off", label: "Off" },
  { id: "en", label: "English" },
  { id: "es", label: "Español" },
  { id: "fr", label: "Français" },
  { id: "de", label: "Deutsch" },
  { id: "it", label: "Italiano" },
  { id: "pt", label: "Português" },
  { id: "ja", label: "日本語" },
  { id: "ko", label: "한국어" },
  { id: "zh", label: "中文" },
  { id: "ar", label: "العربية" },
  { id: "ru", label: "Русский" },
  { id: "hi", label: "हिन्दी" },
];

/**
 * Audio track options with ISO 639-1 language codes
 * Includes variants like 5.1 surround sound
 */
const AUDIO_OPTIONS: AudioOption[] = [
  { id: "en-5.1", label: "English 5.1", icon: StreamingIcons.Uhd },
  { id: "en", label: "English" },
  { id: "es", label: "Español" },
  { id: "fr", label: "Français" },
  { id: "de", label: "Deutsch" },
  { id: "it", label: "Italiano" },
  { id: "pt", label: "Português" },
  { id: "ja", label: "日本語" },
  { id: "ko", label: "한국어" },
  { id: "zh", label: "中文" },
  { id: "ru", label: "Русский" },
  { id: "hi", label: "हिन्दी" },
  { id: "bg", label: "Български" },
  { id: "cs", label: "Čeština" },
  { id: "da", label: "Dansk" },
  { id: "nl", label: "Nederlands" },
  { id: "pl", label: "Polski" },
  { id: "sr", label: "Српски" },
  { id: "sv", label: "Svenska" },
  { id: "tr", label: "Türkçe" },
];

/**
 * Track sections configuration for the subtitle overlay
 * Combines heading, options, and state key for each section
 */
const TRACK_SECTIONS: TrackSection[] = [
  {
    heading: "Subtitles",
    options: SUBTITLE_OPTIONS,
    stateKey: "selectedSubtitle",
  },
  {
    heading: "Audio",
    options: AUDIO_OPTIONS,
    stateKey: "selectedAudio",
  },
];

export { SUBTITLE_OPTIONS, AUDIO_OPTIONS, TRACK_SECTIONS };
